import { removeTrailingSlashes } from './Utils';

const EnvConfig =
  process.env.NODE_ENV === 'development'
    ? `https://${window.location.host}`
    : removeTrailingSlashes(process.env.REACT_APP_URL_SITE);
export default EnvConfig;
